import React from 'react';
export function WhyCoaches() {
  return <section className="bg-ivory px-4 sm:px-6 py-9 sm:py-12" data-id="element-209" data-mp="3lpu1cb7932ht">
      <div className="max-w-2xl mx-auto text-center" data-id="element-210" data-mp="3ergpkszqszbo">
        <h2 className="font-heading font-extrabold uppercase text-lg sm:text-2xl leading-tight tracking-tight text-petrol mb-4" data-id="element-211" data-mp="3epvun29ineda">
          Why coaches use Fitness Senior Ready™
        </h2>

        <p className="text-[13px] sm:text-base text-petrol/70 leading-relaxed mb-4" data-id="element-212" data-mp="34vn2ifoednfn">
          Because they don't need another collection of random workout ideas.
          They need a system they can actually open and use.
        </p>

        <div className="bg-white border-l-4 border-lime rounded-r-lg p-4 text-left mb-4" data-id="element-213" data-mp="2r1mccabih8qw">
          <p className="text-[13px] sm:text-base font-semibold text-petrol leading-snug" data-id="element-214" data-mp="2m3b4u68ovabu">
            A place where exercises connect to sessions.
          </p>
          <p className="text-[13px] sm:text-base font-semibold text-petrol leading-snug" data-id="element-215" data-mp="2h36ja1sxbper">
            Sessions connect to progressions.
          </p>
          <p className="text-[13px] sm:text-base font-semibold text-petrol leading-snug" data-id="element-216" data-mp="3nxuctk0menxw">
            And progressions connect to longer-term programming.
          </p>
        </div>

        <p className="font-heading font-extrabold uppercase text-sm sm:text-lg tracking-tight text-green-dark" data-id="element-217" data-mp="3e0g4y8srj7h7">
          Everything works together.
        </p>
      </div>
    </section>;
}